import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { Grid } from "@material-ui/core";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import Button from "@material-ui/core/Button";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "100%",
  },
  spaceRight: {
    marginRight: theme.spacing(2),
  },
  valueText: {
    marginRight: theme.spacing(6),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
  },
});

class PlaylistRule extends React.Component {
  constructor(props) {
    super(props);

    this.state = { value: props.value };
  }

  updateValue = async (e) => {
    const newValue = e.target.value;
    this.setState({ value: newValue });

    await this.saveUpdateValue();
  };

  saveUpdateValue = AwesomeDebouncePromise(() => {
    this.callOnChange({});
  }, 1000);

  callOnChange = (overrides) => {
    const { field, operator, onChange, orderPosition } = this.props;
    const { value } = this.state;

    if (overrides.field) {
      const newValue = overrides.field === "tag" ? "" : 1;
      this.setState({ value: newValue });
      overrides.value = newValue;
      overrides.operator = overrides.field === "tag" ? "eq" : "geq";
    }

    onChange(
      {
        field: overrides.field != null ? overrides.field : field,
        operator: overrides.operator != null ? overrides.operator : operator,
        value: overrides.value != null ? overrides.value : value,
      },
      orderPosition
    );
  };

  render() {
    const { classes, operator, field, orderPosition, onDelete } = this.props;

    const { value } = this.state;

    return (
      <Grid item xs={12} className={classes.root}>
        <Select
          native
          value={field}
          onChange={(e) => this.callOnChange({ field: e.target.value })}
          className={classes.spaceRight}
        >
          <option value={"rating"}>Rating</option>
          <option value={"tag"}>Tag</option>
        </Select>
        <Select
          native
          value={operator}
          onChange={(e) => this.callOnChange({ operator: e.target.value })}
          className={classes.spaceRight}
        >
          <option value={"eq"}>&#61;</option>
          <option value={"neq"}>&#8800;</option>
          {field === "rating" ? <option value={"g"}>&#62;</option> : <div />}
          {field === "rating" ? (
            <option value={"geq"}>&#8805;</option>
          ) : (
            <div />
          )}
          {field === "rating" ? <option value={"l"}>&#60;</option> : <div />}
          {field === "rating" ? (
            <option value={"leq"}>&#8804;</option>
          ) : (
            <div />
          )}
        </Select>
        <TextField
          value={value}
          onChange={this.updateValue}
          className={classes.valueText}
        />

        <Button
          variant="contained"
          size="small"
          className={classes.deleteButton}
          onClick={() => onDelete(orderPosition)}
        >
          Delete Rule
        </Button>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(PlaylistRule);
